import { useParams } from "react-router-dom";
import { useGetWorkforceQuery } from "./workforce.api";

function useWorkforce() {
  const { workforceId } = useParams<{ workforceId: string }>();
  return useGetWorkforceQuery(workforceId!).data;
}

export default useWorkforce;
